import { FunctionComponent, PropsWithChildren } from 'react';

import { useGetFirmwares } from '../../../../../../../../shared/thunks/get-firmwares/hooks/use-get-firmwares.hook';
import { CampaignFirmwaresSelectProps } from '../../types/campaign-firmwares-select-props.type';

const withFirmwareOptions = (
  Component: FunctionComponent<CampaignFirmwaresSelectProps>
): FunctionComponent<CampaignFirmwaresSelectProps> => {
  return (props: PropsWithChildren<CampaignFirmwaresSelectProps>) => {
    const firmwares = useGetFirmwares(
      props.basicInfoStateFields?.firmwareIds ?? []
    );
    return <Component {...props} options={firmwares} />;
  };
};

export default withFirmwareOptions;
